import { Injectable, OnDestroy, Type } from '@angular/core';
import {
  debounceTime,
  distinctUntilChanged,
  shareReplay,
  Subject,
  switchMap,
} from 'rxjs';
import { TemplateService } from './template.service';
import { TypeEnum } from '../models/template/type.enum';
import { SearchDataRequest } from '../models/template/search-data-request.interface';

@Injectable({
  providedIn: 'root',
})
export class SearchTemplateService {
  searchAtHomeSubject = new Subject<SearchDataRequest>();
  searchAtEditorSubject = new Subject<SearchDataRequest>();

  // Create observable for getting data
  searchAtHome$ = this.searchAtHomeSubject.pipe(
    debounceTime(350),

    // Ignore if text didn’t change
    distinctUntilChanged(),
    // Take only the latest value
    switchMap((searchData: SearchDataRequest) =>
      this.templateService.searchTemplate(searchData)
    )
  );

  searchAtTemplate$ = this.searchAtEditorSubject.pipe(
    debounceTime(350),

    // Ignore if text didn’t change
    distinctUntilChanged(),
    // Take only the latest value
    switchMap((searchData: SearchDataRequest) =>
      this.templateService.searchTemplate(searchData)
    )
  );

  constructor(private templateService: TemplateService) { }

  setSearchAtHomeData(searchData: any) {
    this.searchAtHomeSubject.next(searchData);
  }

  setSearchAtEditorData(searchData: any) {
    this.searchAtEditorSubject.next(searchData);
  }

  /**
   * Checks if the provided search data string is not empty and sets the search template data if valid.
   *
   * @param searchData - The search data string to validate.
   * @returns `true` if the string is not empty and has been set; otherwise, `false`.
   */
  checkSearchDataAtHome(searchData: string, type: TypeEnum = TypeEnum.EMAIL) {
    // If the string is not empty...
    if (searchData && searchData !== '') {
      let searchDataRequest: SearchDataRequest = {
        searchTerm: searchData,
        templateType: type
      }
      this.setSearchAtHomeData(searchDataRequest);
      // String is okay, so return true
      return true;
    }

    // String is not okay, so return false
    else {
      return false;
    }
  }

  checkSearchDataAtEditor(searchData: string, type: TypeEnum = TypeEnum.EMAIL) {
    // If the string is not empty...
    if (searchData && searchData !== '') {
      let searchDataRequest: SearchDataRequest = {
        searchTerm: searchData,
        templateType: type
      }
      this.setSearchAtEditorData(searchDataRequest);
      // String is okay, so return true
      return true;
    }

    // String is not okay, so return false
    else {
      return false;
    }
  }
}
